const suffixMap = new Map<string, string>([
  ['kukai_ios', 'Mobile'],
  ['acurast_ios', 'Lite']
])

export default suffixMap
